import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/sideNavbar/share.png'
import _imports_1 from '@/assets/sideNavbar/whatsapp.png'
import _imports_2 from '@/assets/sideNavbar/sms.png'


const _hoisted_1 = { class: "share_pop" }
const _hoisted_2 = { class: "share_icon" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "share_name" }

import StatusPopup from '@/components/common/statusPopup.vue'
import { ref } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'shareContent',
  setup(__props, { expose: __expose }) {

const show = ref(false)
const shareList = ref([
    { img: require("@/assets/sideNavbar/facebook_cai.png"), name: 'Facebook' },
    { img: require("@/assets/sideNavbar/Whatsapp_cai.png"), name: 'WhatsApp' },
    { img: require("@/assets/sideNavbar/Telegram_cai.png"), name: 'Telegram' },
    { img: require("@/assets/sideNavbar/Twitter.png"), name: 'Twitter' },
    { img: require("@/assets/sideNavbar/email.png"), name: 'Email' }
])
const resData = ref({
    assists: [
        "5511991098602",
        "5511963002295",
        "5551998660068",
        "5541997293702",
        "5547989098177",
        "5531996699079",
        "5562999085639",
        "5531973177762",
        "5531999534506",
        "5562995036596",
        "5511952068120",
        "5561984570216",
        "5561998069429",
        "5541992261435",
        "5521972266621",
        "5541997813925",
        "5511951508833",
        "5511998837920",
        "5531989769510",
        "5551994074604"
    ]
})
const statusRef = ref()
const open = () => {
    show.value = true
}
const close = () => {
    show.value = false
}
const copyText = (value: string) => {
    if (value) {
        navigator.clipboard.writeText(value);
        statusRef.value.open();
    }
}
__expose({
    open,
    close
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((show).value = $event)),
      closeable: "",
      position: "bottom",
      "overlay-style": { overflow: 'hidden' },
      style: {
        width: '100%',
        minHeight: '50%',
    }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "point_text" }, "1. Convide amigos para ajudar com saques", -1)),
          _createVNode(_component_van_row, { class: "share_items" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "4",
                class: "share_item"
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createElementVNode("div", { class: "mais" }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: ""
                    })
                  ], -1),
                  _createElementVNode("div", { class: "share_name" }, "Mais", -1)
                ])),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shareList.value, (item, index) => {
                return (_openBlock(), _createBlock(_component_van_col, {
                  span: "4",
                  key: index,
                  class: "share_item"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("img", {
                        src: item.img,
                        alt: ""
                      }, null, 8, _hoisted_3)
                    ]),
                    _createElementVNode("div", _hoisted_4, _toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_van_row, { class: "copy_row" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, { span: "20" }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("https://688v.team/#/cashwheel?a=styk1ngs")
                ])),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "4",
                class: "copy_text",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (copyText('https://688v.team/#/cashwheel?a=styk1ngs')))
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("Cópia")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "point_text" }, "2. Enviar convite para jogador aleatório ajudar", -1)),
          _createVNode(_component_van_row, { class: "number_plate" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resData.value.assists, (i) => {
                return (_openBlock(), _createBlock(_component_van_col, {
                  span: "5",
                  key: i,
                  class: "num_text"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(i), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              _createVNode(_component_van_col, { span: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_row, {
                    class: "bg_2",
                    justify: "space-between"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_col, { span: "17" }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode("Enviar Mensagem on "),
                          _createElementVNode("span", null, "WhatsApp", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_van_col, { span: "5" }, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createElementVNode("img", {
                            src: _imports_1,
                            alt: ""
                          }, null, -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, { span: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_row, {
                    class: "bg_2",
                    justify: "space-between"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_col, { span: "5" }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createElementVNode("img", {
                            src: _imports_2,
                            alt: ""
                          }, null, -1)
                        ])),
                        _: 1
                      }),
                      _cache[9] || (_cache[9] = _createTextVNode()),
                      _createVNode(_component_van_col, { span: "17" }, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createTextVNode("Enviar Mensagem "),
                          _createElementVNode("span", null, "SMS", -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      content: _ctx.$t('common.copied'),
      isShowSuccess: true
    }, null, 8, ["content"])
  ], 64))
}
}

})